<script>
import { getShadowColor, getFileTypeLogo } from '@/utils/modules/getStyles'
import { getFileType } from '@/utils/common.js'

export default {
  name: 'FileBoxVertical',
  props: {
    headline: {
      type: String,
      default: ''
    },
    filename: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: { getShadowColor, getFileTypeLogo, getFileType }
}
</script>

<template>
  <div class="file-item-vertical" :style="{boxShadow: `0 3px 10px 0 ${getShadowColor(path)}`}">
    <el-image class="file-img" :src="getFileTypeLogo(filename)" alt="file" fit="cover" />
    <p class="name">{{ headline | textLenHandler(12) }}</p>
    <p class="file-type">文件格式: {{ getFileType(filename) || '暂无' }}</p>
  </div>
</template>

<style lang="scss" scoped>
.file-item-vertical {
  width: 190px;
  height: 262px;
  background: #fff;
  border-radius: 5px;
  padding: 38px 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  .file-img {
    width: 113px;
    height: 99px;
    border-radius: 5px;
  }
  .name {
    width: 120px;
    font-size: 15px;
    font-weight: 600;
    color: #000;
    line-height: 21px;
    text-align: center;
    margin-top: 30px;
  }
  .file-type {
    font-size: 13px;
    font-weight: 600;
    color: var(--grey-text-color);
    margin-top: 14px;
  }
}
</style>
